import React, { useState } from "react";
import { Flex, Image, Text, VStack } from "@chakra-ui/react";
import { FILL_10PARENT, FILL_90PARENT, LARGE, MEDIUM, START } from "../Component/constants/typography";
import DeleteandUpdate from "./update"; // Make sure to use the correct import path

export default function BlogLayout({ _id, image, title, description,genre }) {
  return (
    <Flex borderBottom="1px solid orange" alignItems="flex-start" gap={4}>
      <Image w={FILL_10PARENT} src={image} />
      <VStack w={FILL_90PARENT} alignItems={START}>
     
        <Text fontSize={LARGE} fontWeight="bold">
          {title}
        </Text>
        <Text fontSize={MEDIUM} fontWeight="bold">
          {genre}
        </Text>
        <Text fontSize={MEDIUM} fontStyle="italic">
          {description}
        </Text>
        <DeleteandUpdate
          _id={_id}
          initialTitle={title}
          initialDescription={description}
          initialImage={image}
          initialGenre={genre}
        />
      </VStack>
    </Flex>
  );
}